// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer full">
     <div className="container">
         <div className="row">
             <div className="col-lg-3 col-md-12 col-sm-12">
                 <div className="footer-header">
                     <h5>OUR COMPANY</h5>
                 </div>
                 <ul className="footer-list">
                     <li> <Link to='/about/overview'>Overview</Link> </li>
                     <li> <Link to='/about/values'>Values</Link> </li>
                     <li> <Link to='/about/milestones'>Milestones</Link> </li>
                     <li> <Link to='/about/vision'>Vision and Mission</Link> </li>
                     <li> <Link to='/about/team'>Our Team</Link> </li>
                 </ul>


             </div>

             <div className="col-lg-3 col-md-12 col-sm-12">
                 <div className="footer-header">
                     <h5>IMPORTANT INFORMATION</h5>
                 </div>

                 <ul className="footer-list">
                     <li> <Link to='/initiative/our-initiative'>Our Initiatives</Link> </li>
                     <li> <Link to='/initiative/sustainability'>Sustainability</Link> </li>
                    <li> <Link to='/initiative/tracebility'>Traceability</Link> </li>
                 </ul>

             </div>


             <div className="col-lg-3 col-md-12 col-sm-12">
                 <div className="footer-header">
                     <h5>FREQUENTLY USED LINKS</h5>
                 </div>

                 <ul className="footer-list">
                     <li> <Link to='/contactus'>Contact Us</Link> </li>
                     <li> <Link to='/blogs'>Our Blog</Link> </li>
                 </ul>

             </div>


             <div className="col-lg-3 col-md-12 col-sm-12">
                 <div className="footer-logo">
                     <img alt="Cornerstone - Nature, Engineered for Ingredients" src="/assets/images/logo-full.png"/>
                 </div>
                 <p style={{ color: 'var(--brand-cream-dim)', fontSize: 13, marginTop: 14 }}>
                     Nature's power, perfected by science. Oleoresins, essential oils and spice extracts
                     engineered for consistency, potency and performance.
                 </p>
                 {/* <ul className="footer-list">
                     <li>
                         <a href="mailto:enquirykancor@mane.com">enquirykancor@mane.com</a>
                     </li>
                     <li>
                         <a href="javascript:void(0)">CIN: U51909MH1990PTC240460</a>
                     </li>
                 </ul> */}
              {/* <div className="social-links">
        <a href="https://facebook.com" target="_blank" title="Facebook"><i className="fab fa-facebook-f"></i></a>
        <a href="https://twitter.com" target="_blank" title="Twitter"><i className="fab fa-twitter"></i></a>
        <a href="https://instagram.com" target="_blank" title="Instagram"><i className="fab fa-instagram"></i></a>
        <a href="https://linkedin.com" target="_blank" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
        <a href="https://youtube.com" target="_blank" title="YouTube"><i className="fab fa-youtube"></i></a>
    </div> */}
             </div>
         </div>
     </div>
     <a id="back-to-top" href="#" className="back-to-top">
         <span className="ico-lib top"></span>
     </a>
     <div className="copyright-block">
         <div className="container">
             <div className="row">
                 <div className="col-lg-8 col-md-12 col-sm-12 left">
                     <p>Copyright © CornerStone 2025, All rights reserved.</p>
                 </div>
                 <div className="col-lg-4 col-md-12 col-sm-12  text-right"> <p>Designed by <a href="https://globitsoft.com/" target="_blank" style={{color:"white"}}>Globitsoft Solutions</a></p></div>
             </div>
         </div>
     </div>
 </footer>
  );
};

export default Footer;